module.exports = __webpack_public_path__ + "microsoft-teams-logo-71b22454b4950e8279bcb091a3d39b76.png";